{
  "dashboard": {
    "hello": "Hello {{firstname}}",
    "title": "Dashboard",
    "openMissions": "Open missions",
    "pendingRequests": "Pending requests",
    "deliveredRequests": "Delivered requests",
    "companiesTitle": "Your companies",
    "companiesSubtitle": "Manage your companies and track their missions",
    "partner": "Partner",
    "customer": "Customer",
    "followedMissionsTitle": "Followed missions",
    "followedMissionsSubtitle": "Track your missions in real time",
    "requestsCount": "Number of requests",
    "manager": "Manager",
    "noDocumentYet": "No document uploaded yet.",
    "documentsCount": "Number of documents",
    "lastDepositOn": "Last upload on",
    "noFollowedMissionTitle": "No followed mission found",
    "noFollowedMissionText": "You have not followed a mission yet.",
    "requestsTitle": "Requests",
    "requestsSubtitle": "Track requests expiring in 2 days",
    "expiresSoon": "Expires soon",
    "client": "Customer",
    "mission": "Mission",
    "noRequestTitle": "No request found",
    "noRequestText": "You have no request expiring in 2 days.",
    "relaunchTitle": "Follow-ups",
    "relaunchSubtitle": "Follow-ups from the last 7 days",
    "relaunchForMission": "Follow-up of requests for mission",
    "noRelaunchTitle": "No follow-up found",
    "noRelaunchText": "You have no follow-up from the last 7 days.",
    "helpTitle": "Help and Support",
    "helpText": "For any information, please contact support:",
    "error": "An error occurred"
  },
  "help": {
    "title": "Help",
    "text": "For any information, please contact technical support:"
  },
  "common": {
    "error": "An error occurred",
    "sortBy": "Sort by:",
    "back": "Back",
    "backToDashboard": "Back to dashboard",
    "service": "Service",
    "name": "Name",
    "manager": "Manager",
    "dueDate": "Due date",
    "id": "ID",
    "category": "Category",
    "status": "Status",
    "undefined": "Undefined",
    "undefinedFemale": "Undefined",
    "delete": "Delete",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "actions": "Actions",
    "creator": "Creator",
    "yes": "Yes",
    "no": "No",
    "reset": "Reset"
  },
  "status": {
    "legend": "Request statuses:",
    "pending": "Pending",
    "late": "Overdue",
    "delivered": "Delivered",
    "accepted": "Accepted",
    "column": "Request status"
  },
  "customerHome": {
    "missionsTitle": "Missions",
    "missionsSubtitle": "Manage your missions and track their progress",
    "noMissionTitle": "No mission found",
    "noMissionText": "You have no ongoing missions yet. Missions will appear here once they are created."
  },
  "customerRequests": {
    "mission": "Mission",
    "dueDate": "Due date",
    "progress": "Progress:",
    "hideOld": "Hide previous",
    "showOld": "Show previous",
    "creation": "Created",
    "date": "Date",
    "limit": "Deadline",
    "description": "Description",
    "requester": "Requester",
    "docs": "Docs",
    "refused": "Request refused",
    "relaunched": "Request followed up on {{date}} by {{user}}",
    "request": "Request",
    "documents": "Documents",
    "details": "Details",
    "chat": "Chat",
    "documentsList": "Uploaded documents:",
    "noDocuments": "No documents uploaded",
    "uploadDate": "Upload date",
    "type": "Type",
    "documentDeleted": "The document has been deleted",
    "requestDetails": "Request details",
    "requestId": "Request ID",
    "createdAt": "Created on",
    "state": "Status",
    "noDescription": "No description provided",
    "discussion": "Discussion",
    "discussionSubtitle": "Chat with your contact about this request",
    "noMessageTitle": "No messages",
    "noMessageText": "Start the conversation by sending your first message",
    "messagePlaceholder": "Type your message...",
    "newLineHint": "Shift + Enter for a new line",
    "send": "Send"
  },
  "workingFolder": {
    "title": "WORKING FOLDER ACCESS",
    "welcome": "Welcome to Nexum!",
    "wantsToShare": "would like to give you access to the working folder for the mission:",
    "securityHint": "For security reasons, please enter the password you received by email.",
    "password": "Password",
    "validate": "Confirm",
    "expiredTitle": "Access expired",
    "expiredText": "This access has expired. Please contact the person mentioned in the email containing this link.",
    "downloadSuccess": "File downloaded successfully",
    "accessGranted": "Access granted",
    "folderOf": "Here is the working folder of {{name}}",
    "downloading": "Download in progress...",
    "downloadFolder": "Download the folder",
    "wrongPassword": "Incorrect password",
    "downloadError": "Error during download"
  },
  "partner": {
    "fetchClientsError": "Error while fetching customers",
    "fetchDocumentsError": "Error while fetching documents",
    "customersTitle": "Your customer files",
    "customersSubtitle": "Manage your customer files and track their missions",
    "missionsMonitoring": "Missions monitoring",
    "monitoring": "Monitoring",
    "relaunch": "Follow-up",
    "createCustomer": "Create a customer",
    "customerName": "Customer name",
    "missions": "Missions",
    "noCustomerTitle": "No customer found",
    "noCustomerText": "You have not created a customer file yet.",
    "missionsTitle": "Missions",
    "missionsSubtitle": "Manage your missions and track their progress",
    "createWorkingFolder": "Create a working folder",
    "workingFolder": "Working folder",
    "addMission": "Add a mission",
    "archiveDate": "Archive date",
    "noMissionText": "You have not created a mission yet.",
    "renewSuccess": "Mission renewed successfully",
    "watchSuccess": "Mission followed successfully, you will receive notifications",
    "enableNotifs": "Enable notifications",
    "disableNotifs": "Disable notifications",
    "renew": "Renew",
    "edit": "Edit",
    "archive": "Archive",
    "unwatchSuccess": "You will no longer receive notifications",
    "acceptRequests": "You must accept the requests",
    "usersAssigned": "Users assigned successfully",
    "selectStatus": "Please select a status",
    "statusUpdateError": "Error while updating statuses!",
    "requestsTitle": "Requests",
    "archived": "(Archived)",
    "addRequest": "Add a request",
    "importModel": "Import template",
    "exportModel": "Export template",
    "template": "Template",
    "multiAssign": "Bulk assignment",
    "editStatuses": "Edit statuses",
    "importSuccess": "Import successful!",
    "importError": "Error during import!",
    "statusUpdated": "Statuses updated!",
    "refused": "Refused",
    "message": "Message",
    "month": "Month",
    "noRequestText": "You have not created a request for this mission yet.",
    "documentsTitle": "Mission documents",
    "documentsSubtitle": "View and download associated documents",
    "document": "Document",
    "requestId": "Request ID:",
    "documentName": "Document name",
    "depositedOn": "Uploaded on",
    "by": "By",
    "workingFolderTitle": "Working folder",
    "addAccess": "Add access",
    "add": "Add",
    "deleteShort": "Del.",
    "filesAndDocuments": "Files and documents",
    "dropFile": "Drag and drop a file here",
    "orClick": "or click to select a file",
    "file": "File",
    "noFileUploaded": "No file has been uploaded",
    "deleteFile": "Delete file",
    "sendAccessHint": "By clicking \"Send\", an email will be sent to each user of this working folder to give them access to the file.",
    "sendAccess": "Send access",
    "usersWithAccess": "Users with access",
    "user": "User",
    "sendDate": "Sent on",
    "downloaded": "Downloaded",
    "downloadDate": "Download date",
    "availableCollabs": "Available collaborators",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "assignment": "Assignment",
    "resendAccess": "Resend access",
    "revokeAccess": "Revoke access",
    "monitoringTitle": "Requests monitoring",
    "missionManager": "Mission manager",
    "requestStates": "Request statuses",
    "rejectionRate": "Rejection rate",
    "upcomingRequests": "Upcoming requests",
    "deliveryTimes": "Delivery times",
    "acceptanceTimes": "Acceptance times",
    "averageDays": "Average number of days",
    "days": "days",
    "missionsMonitoringTitle": "Missions monitoring",
    "missionsMonitoringSubtitle": "Track your missions progress in real time",
    "customerFiles": "Customer files",
    "filtersAndSort": "Filters and sort",
    "progress": "Progress",
    "urgency": "Urgency",
    "allManagers": "All managers",
    "allCategories": "All categories",
    "missionEnd": "Mission end",
    "noRequestForMission": "No request for this mission",
    "recoveryTitle": "Follow-ups and request information",
    "recoveryHint": "From this page, you can follow up overdue requests or notify pending requests. This action will send an email to all users assigned to the request.",
    "overdueRequests": "Overdue requests",
    "pendingRequests": "Pending requests",
    "overdueCount": "{{count}} overdue request(s)",
    "inProgressCount": "{{count}} pending request(s)",
    "relaunchRequests": "Follow up requests",
    "informRequests": "Notify requests",
    "overdueDays": "Days overdue",
    "waitingDays": "Days waiting",
    "informedOn": "Notified on {{date}} by {{user}}"
  }
}
